import { render, staticRenderFns } from "./SearchRoleSelect.vue?vue&type=template&id=51810f41&scoped=true"
import script from "./SearchRoleSelect.vue?vue&type=script&lang=js"
export * from "./SearchRoleSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchRoleSelect.vue?vue&type=style&index=0&id=51810f41&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51810f41",
  null
  
)

export default component.exports